










import { Component, Vue } from 'vue-property-decorator';
import { setInterval, clearInterval } from 'timers';
import { randRange, PhotoLibrary, isMobile } from '@/scripts';

@Component({
  components: {},
})
export default class Home extends Vue {
  public library = PhotoLibrary;
  public isMobile = isMobile;
}
